<template>
  <div class="Error404 flex min-h-[70vh] items-center justify-center bg-bg px-4 py-16">
    <div class="mx-auto flex max-w-md flex-col items-center text-center">
      <p class="font-display text-7xl font-extrabold tracking-heading text-ink md:text-8xl">
        404
      </p>
      <h1 class="mt-4 font-display text-2xl font-bold tracking-heading text-ink md:text-3xl">
        {{ $t('pages.page_not_found.title') }}
      </h1>
      <p class="mt-3 text-base leading-relaxed text-muted">
        {{ $t('pages.page_not_found.body') }}
      </p>
      <router-link
        :to="$i18nRoute({ name: 'home' })"
        class="mt-8 inline-block rounded-full bg-accent px-[30px] py-3.5 text-sm font-bold text-white no-underline hover:opacity-90"
      >
        {{ $t('pages.page_not_found.cta') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {}
</script>
